module.exports = __webpack_public_path__ + "static/media/review.e2d5037b.svg";